import { PagesGuard } from './../../core/guard/PagesGuard';
import { Routes } from '@angular/router';
export const SEARCH = 'search';

export const DASHBOARD = 'dashboard';
export const PATRIMOINE = 'patrimoine';
export const PATRIMONY = 'patrimony';
export const DEMANDE_SERVICE = 'demandes';
export const REQUESTS_SERVICES = 'requests-services';
export const REQUESTS_PRODUCTS = 'requests-products';
export const SUPERVISORY_REPOSITORY = 'supervisory-repository';
export const DEMANDE_PRODUITS = 'demandes-produits';
export const REFERENTIEL_TELEMETRIE = 'ref-supervision';
export const SUPERVISION_SIM = 'supervision-sim';
export const SUPERVISION_OPERATIONS = 'operations';
export const OPERATION_PROVISIONNING = 'provisionning';
export const ZONE_TRAFIC = 'zone-trafic';
export const REPORTING = 'reporting';
export const SLA_DEMANDE_SERVICE = 'sla-demande-service';
export const INTERCONNEXION_ECHANGE = 'interconnexion';
export const SUPERVISION_SYSTEME = 'supervision-systeme';
export const PARAMETRE_SECURITE = 'parametre-securite';
export const OPERATIONS_SIM = 'operations-sim';
export const STRUCTURE_ORGANISATIONNELLE = 'structure-organisationnelle';
export const ADMIN_USER = 'user';
export const GESTION_IDENTIFICATIONS = 'gestion-identifications';
export const COMPTABILITE = 'comptabilite';
export const ACCOUNTING = 'accounting';
export const OVERSEEING_OPERATIONS = 'overseeing-operations';

// New
export const VEHICULE_FLEET = 'vehicule-fleet';
export const MISSIONS_MANAGEMENT = 'missions-management';
export const MISSION_STATEMENTS = 'mission-statements';
export const PARTNERS_MANAGEMENT = 'partners-management';
export const SETTINGS_AND_SECURITY = 'settings-and-security';
export const CASH_MANAGEMENT = 'cash-management';
export const BILL_OF_LADINGS = 'bill-of-ladings';
export const BILLING = 'billing';


export const content: Routes = [
    {
        path: DASHBOARD,
        loadChildren: () =>
            import('../../presentation/pages/dashboard/dashboard.module').then(
                (m) => m.DashboardModule
            ),
        data: {
            title: 'Tableau de bord',
        },
    },
    {
        path: GESTION_IDENTIFICATIONS,
        loadChildren: () =>
            import(
                '../../presentation/pages/gestion-identifications/gestion-identifications.module'
            ).then((m) => m.GestionIdentificationsModule),
        data: {
            module: "Gestion d'identifications",
            subModule: [
                "File d'attente",
                'Personnes physique',
                'Equipements connecté',
            ],
        },
    },
    {
        path: PATRIMONY,
        loadChildren: () =>
            import('../../presentation/pages/patrimony/patrimony.module').then(
                (m) => m.PatrimonyModule
            ),
        data: {
            module: 'Patrimoine',
            subModule: [
                'MY_SIM_CARDS',
                'WHITE_SIM',
                // 'Dotation Data',
                'Etat des soldes Data',
                'Etat des soldes SMS',
                'Téléchargements',
                'SIM_IMPORTATION',
                // 'Cartographie',
            ],
        },
    },
    {
        path: REQUESTS_SERVICES,
        loadChildren: () =>
            import(
                '../../presentation/pages/requests-services/requests-services.module'
            ).then((m) => m.RequestsServicesModule),
        data: {
            module: 'REQUESTS_SERVICES',
            subModule: [
                'MOBILE_SUBSCRIPTIONS',
                'SIM_IMPORTATION',
                'Suspensions',
                'Résiliations',
                'Changements de Formules',
            ],
        },
    },
    {
        path: DEMANDE_PRODUITS,
        loadChildren: () =>
            import(
                '../../presentation/pages/demandes-produits/demandes-produits.module'
            ).then((m) => m.DemandesProduitsModule),
        data: {
            module: 'Commande produits',
            subModule: ['SIM Blanches'],
        },
    },
    {
        path: REQUESTS_PRODUCTS,
        loadChildren: () =>
            import(
                '../../presentation/pages/requests-products/requests-products.module'
            ).then((m) => m.RequestsProductsModule),
        data: {
            module: 'REQUESTS_PRODUCTS',
            subModule: ['SIM_ORDERS'],
        },
    },
    {
        path: OVERSEEING_OPERATIONS,
        loadChildren: () =>
            import(
                '../../presentation/pages/overseeing-operations/overseeing-operations.module'
            ).then((m) => m.OverseeingOperationsModule),
        data: {
            module: 'OVERSEEING_OPERATIONS',
            subModule: [
                'WAITING_QUEUE',
                'TREATMENT_MONITORING',
                'CLAIMS',
                'MY_NOTIFICATIONS',
                'MY_INBOX',
            ],
        },
    },
    {
        path: REFERENTIEL_TELEMETRIE,
        loadChildren: () =>
            import(
                '../../presentation/pages/ref-telemetrie/ref-telemetrie.module'
            ).then((m) => m.RefTelemetrieModule),
        data: {
            title: REFERENTIEL_TELEMETRIE,
            module: 'SUPERVISORY_REPOSITORY',
            subModule: [
                'INDICATORS_ALARMS',
                'SUPERVISORY_PROFILES',
                'SLA_AGREEMENTS',
                'SLA_MANAGEMENT_CONTRACT',
            ],
        },
    },
    {
        path: OPERATION_PROVISIONNING,
        loadChildren: () =>
            import(
                '../../presentation/pages/provisionning/provisionning.module'
            ).then((m) => m.ProvisionningModule),
        data: {
            title: 'SUPERVISORY_REPOSITORY',
            module: 'SUPERVISORY_REPOSITORY',
            subModule: [
                'INDICATORS_ALARMS',
                'SUPERVISORY_PROFILES',
                'SLA_AGREEMENTS',
                'SLA_MANAGEMENT_CONTRACT',
            ],
        },
    },
    {
        path: SUPERVISION_OPERATIONS,
        loadChildren: () =>
            import(
                '../../presentation/pages/supervision-operations/supervision-operations.module'
            ).then((m) => m.SupervisionOperationsModule),
    },
    {
        path: COMPTABILITE,
        loadChildren: () =>
            import(
                '../../presentation/pages/comptabilite/comptabilite.module'
            ).then((m) => m.ComptabiliteModule),
        data: {
            module: 'Comptabilité',
            subModule: ['Facture'],
        },
    },
    {
        path: ACCOUNTING,
        loadChildren: () =>
            import(
                '../../presentation/pages/accounting/accounting.module'
            ).then((m) => m.AccountingModule),
        data: {
            module: 'ACCOUNTING',
            subModule: [
                'MY_ACCOUNT_CREDITS',
                'MY_INVOICES',
                'MY_PAYMENTS',
                'MY_ACCOUNT_STATEMENT',
            ],
        },
    },
    {
        path: ZONE_TRAFIC,
        loadChildren: () =>
            import(
                '../../presentation/pages/zone-trafic/zone-trafic.module'
            ).then((m) => m.ZoneTraficModule),
        data: { title: ZONE_TRAFIC },
    },
    {
        path: REPORTING,
        loadChildren: () =>
            import('../../presentation/pages/reporting/reporting.module').then(
                (m) => m.ReportingModule
            ),
        data: { title: ZONE_TRAFIC },
    },
    {
        path: SUPERVISION_SIM,
        loadChildren: () =>
            import(
                '../../presentation/pages/analyse-alerte/analyse-alerte.module'
            ).then((m) => m.AnalyseAlerteModule),
        data: {
            title: SUPERVISION_SIM,
            module: 'SUPERVISION_SIM',
            subModule: [
                'ALARM_ANALYSIS_SMS',
                'ALARM_ANALYSIS_DATA',
                'DETECTION_SUPPLIES_DATA',
                'DETECTION_SUPPLIES_SMS',
            ],
        },
    },
    {
        path: INTERCONNEXION_ECHANGE,
        loadChildren: () =>
            import(
                '../../presentation/pages/interconnexion/interconnexion.module'
            ).then((m) => m.InterconnexionModule),
        data: { title: INTERCONNEXION_ECHANGE },
    },
    {
        path: SLA_DEMANDE_SERVICE,
        loadChildren: () =>
            import(
                '../../presentation/pages/sla-demande-service/sla-demande-service.module'
            ).then((m) => m.SlaDemandeServiceModule),
        data: {
            module: 'Reporting SLA',
            subModule: [
                'Tableau de bord demandes',
                'Rapport Performances',
                'tableau de bord dossiers',
            ],
        },
    },
    {
        path: PARAMETRE_SECURITE,
        loadChildren: () =>
            import(
                '../../presentation/pages/parametre-securite/parametre-securite.module'
            ).then((m) => m.ParametreSecuriteModule),
        data: { title: PARAMETRE_SECURITE },
    },
    {
        path: OPERATIONS_SIM,
        loadChildren: () =>
            import(
                '../../presentation/pages/operation-sim/operation-sim.module'
            ).then((m) => m.OperationSimModule),
    },
    {
        path: ADMIN_USER,
        loadChildren: () =>
            import(
                '../../presentation/pages/administration/administration.module'
            ).then((m) => m.AdministrationModule),
        data: {
            module: 'User',
            subModule: [
                'Ventes',
                'Stock',
                'Produits',
                'Achats',
                'Clients',
                'Historique des activations',
                'Groupes',
                'Point de Ventes',
            ],
        },
    },
    {
        path: VEHICULE_FLEET,
        loadChildren: () =>
            import(
                '../../presentation/pages/vehicule-fleet/vehicule-fleet.module'
            ).then((m) => m.VehiculeFleetModule),
        data: {
            module: "Parc automobile",
            subModule: [
                'Liste des chauffeurs',
            ],
        },
    },
    {
        path: MISSIONS_MANAGEMENT,
        loadChildren: () =>
            import(
                '../../presentation/pages/missions-management/missions-management.module'
            ).then((m) => m.MissionsManagementModule),
        data: {
            module: "Gestion des missions",
            subModule: [
                'Paramétrage itinéraires',
            ],
        },
    },
    {
        path: MISSION_STATEMENTS,
        loadChildren: () =>
            import(
                '../../presentation/pages/mission-statements/mission-statements.module'
            ).then((m) => m.MissionStatementsModule),
        data: {
            module: 'État des frais de mission',
            subModule: [
                'État des frais',
                'État des pesages',
            ],
        },
    },
    {
        path: PARTNERS_MANAGEMENT,
        loadChildren: () =>
            import(
                '../../presentation/pages/partners-management/partners-management.module'
            ).then((m) => m.PartnersManagementModule),
        data: {
            module: "Partenaires",
            subModule: [
                'Liste des clients',
                'Liste des fournisseurs',
            ],
        },
    },
    {
        path: SETTINGS_AND_SECURITY,
        loadChildren: () =>
            import(
                '../../presentation/pages/settings-and-security/settings-and-security.module'
            ).then((m) => m.SettingsAndSecurityModule),
        data: {
            module: 'Paramètres et Sécurité',
            subModule: [
                'Paramètres de base',
            ],
        },
    },
    {
        path: CASH_MANAGEMENT,
        loadChildren: () =>
            import(
                '../../presentation/pages/cash-management/cash-management.module'
            ).then((m) => m.CashManagementModule),
        data: {
            module: 'Gestion de la caisse',
            subModule: [
                'Bon de caisse d\'entrée',
            ],
        },
    },
    {
        path: STRUCTURE_ORGANISATIONNELLE,
        loadChildren: () =>
            import(
                '../../presentation/pages/structure-niveau/structure-niveau.module'
            ).then((m) => m.StructureNiveauModule),
        data: {
            module: 'Structure Organisationnelle',
        },
    },
    {
        path: BILL_OF_LADINGS,
        loadChildren: () =>
            import(
                '../../presentation/pages/bill-of-ladings/bill-of-ladings.module'
            ).then((m) => m.BillOfLadingsModule),
        data: {
            module: 'Bill of Ladings',
            subModule: [
                'Importations de BL',
            ],
        },
    },
    {
        path: BILLING,
        loadChildren: () =>
            import(
                '../../presentation/pages/billing/billing.module'
            ).then((m) => m.BillingModule),
        data: {
            module: 'Facturation',
            subModule: [
                'État transporteurs',
                'Factures transporteurs',
            ],
        },
    },
    {
        path: '',
        redirectTo: DASHBOARD,
        pathMatch: 'full',
    },
    {
        path: '**',
        redirectTo: DASHBOARD,
    },
];
